module.exports = __webpack_public_path__ + "media/images/dot-7c41ac80554fd369c15d431ca57aafb2.png";